import {GetSeferData} from "SeferPetach/GetData";

export async function getProfilePhotosList() {
    var args = {
        'TYPE_ID': 1,
        'ITEM_STATUS': 1
    };
    var payload = await GetSeferData("af3", args);
    return (payload);
}

export async function getProfilePhotoByID(file_id, type_id){
    var args = {
        'FILE_ID': file_id,
        'TYPE_ID': type_id
    };
    var payload = await GetSeferData("af4", args);
    return (payload);
}

export async function updateProfilePhoto(obj) {
    var args        = obj;
    var payload     = await GetSeferData("af1", args);
    return (payload);
}

export async function deleteProfilePhoto(file_id, type_id){
    var args = {
        'FILE_ID': file_id,
        'TYPE_ID': type_id
    };
    var payload = await GetSeferData("af5", args);
    return (payload);
}